import{jsx as i,jsxs as o}from"react/jsx-runtime";import t from"styled-components";import{useTranslation as n}from"react-i18next";import r from"../../../../../assets/profileSettingsWhatsApp/android/lock-icon.svg.js";import c from"../../../../../assets/profileSettingsWhatsApp/android/switch-icon.svg.js";import{Divider as e,Wrapper as s}from"./styled.js";const m=t.div`
  opacity: 0.2;
`,p=t.p`
  font-size: 14px;
  font-weight: 400;
  color: rgb(21, 21, 21);
  margin: 0;

  span {
    display: block;
    font-size: 12px;
    margin-top: 8px;
  }
`,d=t.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${e}

  &:not(:last-child) {
    margin-bottom: 8px;
    padding-bottom: 8px;
  }
`,l=()=>{const{t:t}=n();return i(s,{children:o(m,{children:[o(d,{children:[i(p,{children:t("common.muteNotifications")}),i("img",{alt:t("imgAlt.androidSwitchIcon"),src:c})]}),i(d,{children:i(p,{children:t("common.customNotifications")})}),i(d,{children:i(p,{children:t("common.mediaVisibility")})}),o(d,{children:[o(p,{children:[t("common.encryption"),i("span",{children:t("common.encryptionDescription")})]}),i("img",{alt:t("imgAlt.androidLockIcon"),src:r})]})]})})};export{l as NotificationsSection};
//# sourceMappingURL=NotificationsSection.js.map
